<template>
  <v-container fluid class="px-10 py-4">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">
      <v-col cols="4">
        <v-select
          v-model="company_id"
          :items="companyOptions"
          item-text="name"
          item-value="id"
          menu-props="auto"
          hide-details
          label="所属拆迁公司"
          single-line
          style="max-width: 120px;"
        ></v-select>
      </v-col>

      <v-col style="text-align: right;" cols="8">
        <v-btn @click="goBack" class="primary mx-3">
          <i class="mdi mdi-arrow-left-bold"></i>返回
        </v-btn>
        <v-btn @click="confirm" class="primary my-btn mx-3">
        <i class="mdi mdi-card-account-details"></i>保存
      </v-btn>
        <v-btn @click="getList" color="primary" class="mx-3">
          查询
          <v-icon right>mdi-magnify</v-icon>
        </v-btn>
        <v-btn @click="resetQuery" color="primary" class="mx-3">
          重置
          <v-icon right>mdi-lock-reset</v-icon>
        </v-btn>
        <v-btn @click="goFile" color="red" class="mx-3">
          文件管理
          <v-icon right>mdi-format-list-bulleted</v-icon>
        </v-btn>
      </v-col>
    </v-row>


    <v-alert
      :value="alert"
      color="red"
      dark
      border="top"
      icon="mdi-bell"
      transition="scale-transition"
    >
      {{ alert_text }}
    </v-alert>
    <v-card>
      <br>
      <v-card-text>
        <row class="customer_name">
         {{items[0].customer}} 
        </row>        
        <row style="font-size:12px;color: #fff">{{items[0].village}} {{items[0].address}} {{ items[0].note }}</row>
      </v-card-text>   
        <v-divider class="mb-1 mx-2" />
    <v-simple-table fixed-header class="mytable">
      <template v-slot:default>
        <thead>
          <tr>
            <td><th></th></td>
            <td><th width="200"></th></td>
            <td>
            <th width="180">标准安置面积</th>
            <th width="180">产权置换面积</th>
            <th width="180">特殊面积</th>
            <th width="180">不可分割面积</th>
            <th width="180">市场优惠面积</th>
            <th width="180">自行车库面积</th>
            </td>
            <td><th width="200">买受人</th></td>
            <td><th width="200"></th></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in items" :key="i">
            <td>
              {{ i + 1 }}
            </td>
            <td class="text-left">
              {{ row.garden_name }} {{ row.building_name }}幢 {{ row.unit_name }}单元 {{ row.house_number }}
             <span v-if="row.delivery_time"> <br />
              交房时间：{{ $moment(row.delivery_time).utc().format("YYYY-MM-DD HH:mm:ss") }}</span>
            </td>
            <td>
              <v-simple-table dense class="background-transparent mytable">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td width="100">{{ row.population_area }}㎡</td>
                      <td width="100">{{ row.property_area }}㎡</td>
                      <td width="100">{{ row.special_area }}㎡</td>
                      <td width="100">{{ row.extend_area }}㎡</td>
                      <td width="100">{{ row.market_discount_area }}㎡</td>
                      <td width="100">{{ row.sub_area }}㎡</td>
                    </tr>
                    <tr>
                      <td>
                        {{ row.population_price_discount }}元/㎡
                      </td>
                      <td>{{ row.property_price_discount }}元/㎡</td>
                      <td>{{ row.special_price_discount }}元/㎡</td>
                      <td>{{ row.extend_price_discount }}元/㎡</td>
                      <td>
                        {{ row.market_discount_price_discount }}元/㎡
                      </td>
                      <td>{{ row.sub_price }}元/㎡</td>
                    </tr>
                    <tr class="fee">
                      <td>
                        {{ row.population_fee }}
                      </td>
                      <td>
                        {{ row.property_fee }}
                      </td>
                      <td>
                        {{ row.special_fee }}
                      </td>
                      <td>
                        {{ row.extend_fee }}
                      </td>
                      <td>
                        {{ row.market_discount_fee }}
                      </td>
                      <td>
                        {{ row.sub_fee }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </td>
            <td v-if="row.agreement[0]">
              {{ row.agreement[0].customer }}
              {{ row.agreement[0].customer_array }}
            </td>
            <td v-else>
             
            </td>
            <td class="total_fee">
              {{ row.total_fee }}元
              <br>
              <v-btn
                :color="printer.time.color"
                icon
                small
                @click="handleUpdateContract(row,  i + 1)"
                :disabled="row.status==1"
              >
                <!-- <v-icon v-text="printer.time.icon" /> -->
                <v-icon>{{ printer.time.icon }}</v-icon>
              </v-btn>
              <v-btn
                :color="printer.eye.color"
                icon
                small
                @click="handlePrintBill(row,  i + 1)"
                title="结算清单"
              >
                <!-- <v-icon v-text="printer.eye.icon" /> -->
                <v-icon>{{ printer.eye.icon }}</v-icon>
              </v-btn>
              
              <v-btn
                :color="printer.contract.color"
                icon
                small
                @click="handlePrintContractForSJ(row,  i + 1)"
                title="公寓房安置买卖合同"
                v-if="row.garden_name=='东韵华庭' || row.garden_name=='金晖嘉苑'"
                >
                <!-- <v-icon v-text="printer.contract.icon" /> -->
                <v-icon>{{ printer.contract.icon }}</v-icon>
              </v-btn>
              <v-btn
                :color="printer.contract.color"
                icon
                small
                @click="handlePrintContractForHS(row,  i + 1)"
                title="公寓房安置买卖合同"
                v-else-if="row.garden_name=='和善家园二期'"
                >
                <!-- <v-icon v-text="printer.contract.icon" /> -->
                <v-icon>{{ printer.contract.icon }}</v-icon>
              </v-btn>
              <v-btn
                :color="printer.contract.color"
                icon
                small
                @click="handlePrintContractForSX(row,  i + 1)"
                title="公寓房安置买卖合同"
                v-else-if="row.garden_name=='善新苑' || row.garden_name=='凤桐雅苑' || row.garden_name=='珑港华庭'"
                >
                <!-- <v-icon v-text="printer.contract.icon" /> -->
                <v-icon>{{ printer.contract.icon }}</v-icon>
              </v-btn>
              <v-btn
                :color="printer.contract.color"
                icon
                small
                @click="handlePrintContract(row,  i + 1)"
                title="公寓房安置买卖合同"
                v-else
              >
                <!-- <v-icon v-text="printer.contract.icon" /> -->
                <v-icon>{{ printer.contract.icon }}</v-icon>
              </v-btn>
              <v-btn
                :color="printer.settle.color"
                icon
                small
                @click="handlePrintSettle(row,  i + 1)"
                title="安置结算同意书"
              >
                <!-- <v-icon v-text="printer.settle.icon" /> -->
                <v-icon>{{ printer.settle.icon }}</v-icon>
              </v-btn>
              <!-- <AddDeliveryTimeDialog /> -->
              
              <v-btn
                :color="printer.cancel.color"
                icon
                small
                @click="resetContract(row)"
                :disabled="row.status==0"
              >
                <v-icon>{{ printer.cancel.icon }}</v-icon>
              </v-btn>
              <v-btn  
                :color="printer.success.color"
                icon
                small
                @click="handleUpdateSuccessContract(row)"
                v-if="row.is_success==0"
                title="完成交房"
              >
                <v-icon>{{ printer.success.icon }}</v-icon>
              </v-btn>
               <v-btn  
                :color="printer.unsuccess.color"
                icon
                small
                @click="cancelSuccessContract(row)"
                v-if="row.is_success==1"
                title="取消完成"
              >
                <v-icon>{{ printer.unsuccess.icon }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="text-center">
      <v-row justify="center" align="center">
        <v-pagination
          v-model="listQuery.page"
          :circle="circle"
          :disabled="disabled"
          :length="total_pages"
          :next-icon="nextIcon"
          :prev-icon="prevIcon"
          :total-visible="totalVisible"
          :value="listQuery.page"
          @input="paginationChangeHandler"
        ></v-pagination>
        <!-- <span>共{{total_pages}}页</span> -->
      </v-row>
    </div>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>
  <v-dialog v-model="dialog" max-width="600">
    <v-container class="px-3 my-container">
      <!-- <v-card-title class="headline">编辑</v-card-title> -->

      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10"><h1>交房时间</h1></v-card-title>
        <v-row>
          <v-menu
            v-model="end_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="temp.delivery_time"
                label="交房时间"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="temp.delivery_time"
              @input="end_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-row>
        
        <v-row>
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelAddDialog">取消</v-btn>
          <v-btn color="primary" @click="confirmAddDialog">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
    <v-dialog v-model="Transition" max-width="1200">
      <v-container id="printMe" class="px-3 pt-5 pb-10 dialog-style">
        <v-row class="d-flex justify-space-between mx-1 mb-0">
          <v-card-title class="mx-12 mt-3">
            {{ items[0].customer }}
          </v-card-title>
        </v-row>

        <p class="mx-16">{{ items[0].village }} {{ items[0].myarea }}㎡ {{ items[0].cardid }}</p>
        <p class="mx-16">腾空时间：{{ items[0].delivery_time_export }}</p>
        <v-simple-table dense class="mx-15 mt-6 dialog-style" v-if="items[0]">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="">
                  序号
                </th>
                <th>
                  房号
                </th>
                <th>
                  面积
                </th>
                <th>
                  交房时间
                </th>
                <th>
                过渡费(元)
                </th>
               
              </tr>
            </thead>
            <tbody>
              <tr v-for="(detail, i) in transitionList" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ detail.garden_name }} {{ detail.building_name }}幢 {{ detail.unit_name }}单元 {{ detail.house_number }}室</td>
                <td>{{ detail.area }}㎡</td>
                <td>{{ detail.delivery_time_export }}</td>
                <td>{{ detail.transitionTotal }}</td>
                
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>总</td>
                <td>{{ total_fee }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>已发放</td>
                <td>{{ totalFeeIssued }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>差价</td>
                <td>{{ total_fee-totalFeeIssued }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import { updateCustomerById } from "@/api/customers";
import { fetchContracts,updateContractDelivery,updateContractDeliveryCheck,cancelContractDelivery,updateContractSuccess,cancelContractSuccess,fetechContractTransition } from "@/api/contracts";
import { fetchCompanyList } from "@/api/companies";
import { recordLog } from "@/utils/log";

// const statusOptions = [
//   { key: 0, display_name: "空闲" },
//   { key: 1, display_name: "已选" },
//   { key: 9, display_name: "剔除" }
// ];

export default {
  name: "Bills",

  components: {
    // AddDeliveryTimeDialog: () => import("./addDeliveryTimeDialog")
  },

  data: () => ({
    Transition:false,
    transitionList:[],
    snackbar: false,
    text: "",
    timeout: 3000,
    alert: false,
    alert_text: "",
    dialog:false,
    printer: {
      single: {
        color: "blue",
        icon: "mdi-printer"
      },
      batch: {
        color: "secondary",
        icon: "mdi-printer"
      },
      cancel: {
        color: "red",
        icon: "mdi-lock-reset"
      },
      eye: {
        color: "warning",
        icon: "mdi-eye"
      },
      contract: {
        color: "blue",
        icon: "mdi-home-edit"
      },
      settle: {
        color: "blue",
        icon: "mdi-content-save-edit"
      },
      
      time:{
        color:"green",
        icon:"mdi-clock-edit"
      },
      success:{
        color:"green",
        icon:"mdi-check-circle"
      },
      unsuccess:{
        color:"red",
        icon:"mdi-close-circle-outline"
      }
    },
    action: {
      color: "info",
      icon: "mdi-message-text"
    },
    exportItems: [],
    items: [],
    listQuery: {
      page: 1,
      limit: 10,
      sort: "+id"
    },
    surplus:0,
    search: undefined,
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    greenColor: "rgb(81, 185, 116)",
    blankColor: "rgb(90, 90, 90)",
    redColor: "rgb(231, 111, 111)",
    starColor: "rgb(240, 70, 70)",
    orangeColor: "rgb(247, 172, 11)",
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,
    // statusOptions,
    companyOptions:[],
    company_id:"",
    temp: {
      id: "",
      delivery_time: "",
    },
    exportFields: {
      序号: "id",
      小区或地块: "garden",
      楼幢: "building",
      单元: "unit",
      门牌: "number",
      楼层: "floor",
      状态: "status",
      面积: "area",
      自行车库: "sub_area",

      号箱: "box_name",
      号箱描述: "box_description",
      户型类别: "house_type",
      创建日期: "create_time"
      // "Telephone 2": {
      //   field: "phone.landline",
      //   callback: value => {
      //     return `Landline Phone - ${value}`;
      //   }
      // }
    }
  }),

  computed: {
    isAdminRole() {
      // console.log("roles: ", this.$store.getters.roles);
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getList();
    this.getCompaniesList()
  },
  watch: {
    // search: function (val) {
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       this.getList()
    //       this.awaitingSearch = false
    //     }, 1500); // 1 sec delay
    //   }
    //   this.awaitingSearch = true
    //   console.log('this.listQuery.status:', this.listQuery.status)
    // },
  },
  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getQuery() {
      setTimeout(() => this.getList(), 500);
    },
    // changed() {
    //   console.log(
    //     this.listQuery.isAudioBook
    //   )
    // },
    getCompaniesList() {
      this.listLoading = true;
      console.log("getCompaniesList");
      fetchCompanyList().then(response => {
        this.companyOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },
    confirm() {
      const data = {
        'company_id':this.company_id
      }
      // console.log(tempData);
      updateCustomerById(this.$route.params.id,data).then(response => {
        this.text = "数据保存成功";
        this.snackbar = true;
        
      });
      
    },
    getList() {
      console.log("xxxx");
      this.listLoading = true;
      this.listQuery.limit = 10;
      //  this.listQuery.get_desc_time = true;
      var query_params = { customer_id: this.$route.params.id,orderby_time_desc:true };
      fetchContracts(query_params).then(response => {
        this.items = response.data.items;
        this.total_pages = response.data._meta.total_pages;
        console.log(this.items);
        var surplus = 0
        var company_id ;
        this.items.forEach(item => {
          company_id = item.company_id
          if (item.status === 1) {
            // console.log(key, item.key, item.display_name)
            surplus++;
          }
          this.surplus = surplus;
        });
        this.company_id = company_id;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

    handlePrintBill(row, sequence) {
      // if(row.status==0){
      //   this.alert_text = "当前房源还未确认交房！";
      //   this.alert = true;
      //   setTimeout(() => {
      //     this.alert = false;
      //   }, 2 * 1000);
      //   return false;
      // }
      recordLog({
        event: '结算清单',
        customername: this.items.length ? this.items[0].customer : '',
        api: '打印结算单',
        details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
      });
      this.$router.push({
        name: "打印结算单",
        params: {
          id: row.id,
          seq: sequence
        }
      });
    },
    handlePrintContract(row, sequence) {
      // if(row.status==0){
      //   this.alert_text = "当前房源还未确认交房！";
      //   this.alert = true;
      //   setTimeout(() => {
      //     this.alert = false;
      //   }, 2 * 1000);
      //   return false;
      // }
      recordLog({
        event: '买卖合同',
        customername: this.items.length ? this.items[0].customer : '',
        api: '打印合同',
        details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
      });
      this.$router.push({
        name: "打印合同",
        params: {
          id: row.id,
          seq: sequence
        }
      });
    },
    handlePrintContractForSJ(row, sequence) {
      // if(row.status==0){
      //   this.alert_text = "当前房源还未确认交房！";
      //   this.alert = true;
      //   setTimeout(() => {
      //     this.alert = false;
      //   }, 2 * 1000);
      //   return false;
      // }
      recordLog({
        event: '买卖合同',
        customername: this.items.length ? this.items[0].customer : '',
        api: '打印买卖合同',
        details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
      });
      this.$router.push({
        name: "打印买卖合同",
        params: {
          id: row.id,
          seq: sequence
        }
      });
    },
    handlePrintContractForSX(row, sequence) {
      recordLog({
        event: '买卖合同',
        customername: this.items.length ? this.items[0].customer : '',
        api: '打印善新苑买卖合同',
        details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
      });
      this.$router.push({
        name: "打印善新苑买卖合同",
        params: {
          id: row.id,
          seq: sequence
        }
      });
    },
    handlePrintContractForHS(row, sequence) {
      recordLog({
        event: '买卖合同',
        customername: this.items.length ? this.items[0].customer : '',
        api: '打印和善家园买卖合同',
        details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
      });
      this.$router.push({
        name: "打印和善家园买卖合同",
        params: {
          id: row.id,
          seq: sequence
        }
      });
    },
    handlePrintSettle(row, sequence) {
      // if(row.status==0){
      //   this.alert_text = "当前房源还未确认交房！";
      //   this.alert = true;
      //   setTimeout(() => {
      //     this.alert = false;
      //   }, 2 * 1000);
      //   return false;
      // }
      console.log(this.surplus)
      recordLog({
        event: '安置结算同意书',
        customername: this.items.length ? this.items[0].customer : '',
        api: '打印同意书',
        details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
      });
      this.$router.push({
        name: "打印同意书",

        params: {
          id: row.id,
          seq: sequence,
          surplus:this.surplus,
        }
      });
    },
    handleUpdateContract(row) {
      this.listLoading = true;
      this.$confirm("确定要交房吗?").then(res => {
        if (res) {
          recordLog({
            event: '交房',
            customername: this.items.length ? this.items[0].customer : '',
            api: '/contracts/delivery',
            details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
          });
          // this.temp.id = row.id
          var data = {
            id: row.id
          };
          updateContractDeliveryCheck(data).then((response) => {
            if (response.data.error) {
              this.$confirm(response.data.error).then(res => {
                if (res) {
                  updateContractDelivery(data).then((response) => {
                        this.dialog = false;
                        this.temp = {};
                        this.getList();
                        this.goTransition(row.customer_id)
                        // fetechContractTransition({id:row.customer_id}).then((r)=>{
                        //   // 
                          

                        //   // console.log(this.transitionList[0])
                        // })
                  });
                }
              })
                
            } else {
                this.dialog = false;
                this.temp = {};
                this.getList();
            }
            
          });
        }
      });
    },
    goTransition(id) {
      // console.log(row.id)
      this.$router.push({
        name: "过渡费",
        params: { id: id }
      });
    },
    goFile(){
      this.$router.push({
        name: "文件管理",
        params: { id: this.$route.params.id }
      });
    },
    resetContract(row) {
      this.listLoading = true;
      this.$confirm("确定要取消交房吗?").then(res => {
        if (res) {
          recordLog({
            event: '取消交房',
            customername: this.items.length ? this.items[0].customer : '',
            api: '/contracts/delivery/cancel',
            details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
          });
          var data = {
            id: row.id
          };
          cancelContractDelivery(data).then(response => {
            this.getList();
            setTimeout(() => {
              this.listLoading = false;
            }, 5 * 1000);
          });
        }
      });
    },
     handleUpdateSuccessContract(row) {
      this.listLoading = true;
      this.$confirm("确定要完成交房吗?").then(res => {
        if (res) {
          recordLog({
            event: '完成交房',
            customername: this.items.length ? this.items[0].customer : '',
            api: '/contracts/success',
            details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
          });
          // this.temp.id = row.id
          var data = {
            id: row.id
          };
          updateContractSuccess(data).then((response) => {
            
            if (response.data.error) {
                  this.alert_text = response.data.error;
                  this.alert = true;
                } else {
                  this.dialog = false;
                  this.temp = {};
                  this.getList();
            }
            setTimeout(() => {
              this.alert_text = "";
              this.alert = false;
            }, 1.5 * 1000);
          });
        }
      });
    },
    cancelSuccessContract(row) {
      this.listLoading = true;
      this.$confirm("确定要取消吗?").then(res => {
        if (res) {
          recordLog({
            event: '取消完成',
            customername: this.items.length ? this.items[0].customer : '',
            api: '/contracts/success/cancel',
            details: `${row.garden_name}${row.building_name}幢${row.unit_name}单元${row.house_number}`
          });
          var data = {
            id: row.id
          };
          cancelContractSuccess(data).then(response => {
            this.getList();
            setTimeout(() => {
              this.listLoading = false;
            }, 5 * 1000);
          });
        }
      });
    },
    confirmAddDialog() {
      const tempData = this.temp;
      console.log(tempData);
      updateContractDelivery(tempData).then(() => {
        this.dialog = false;
        this.temp = {};
        this.getList();
      });
    },

    cancelAddDialog() {
      this.dialog = false;
      this.temp = {};
    },
    resetQuery() {
      this.listQuery = {
        page: 1,
        limit: 10,
        sort: "+id"
      };
      this.getList();
    },

    getNamefromOptions(options, key) {
      // return options[key]
      let showname = "";
      options.forEach(item => {
        if (item.key === key) {
          // console.log(key, item.key, item.display_name)
          showname = item.display_name;
        }
      });
      return showname;
    },

    paginationChangeHandler(pageNumber) {
      this.listQuery.page = pageNumber;
      this.getList();
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },
    
  }
};
</script>

<style scoped>
#box ul {
  display: flex;
  flex-wrap: wrap;
}
#box li {
  padding: 3px;
  list-style: none;
  margin-right: 15px;
  border: 1px solid #eee;
}

.book {
  width: 100px;
  /* height: 150px; */
  display: block;
  margin: 0 auto;
}

table,
thead,
th {
  color: rgb(11, 105, 247) !important;
  border-bottom: none;
}

table,
thead,
tr {
  color: #fff;
  font-weight: 400;
  border-bottom: none;
}
th {
  font-size: 11px !important;
  text-align: right !important;
}

td {
  font-size: 13px !important;
  text-align: right !important;
}

.fee {
  font-weight: 600 !important;
  color: rgb(15, 126, 201);
}

.total_fee {
  color: rgb(253, 113, 113);
  font-weight: 800;
}

tr:hover {
  background-color: #0282b4 !important;
  color: rgb(224, 221, 221);
}

table { border-collapse:collapse } 
table td, table th {
  height: 50px; 
}

.customer_name {
  color:chocolate;
  font-size:24px;
  margin: 10 0 0 0 !important;
}
.dialog-style {
  background-color: rgb(40, 40, 40) !important;
}
</style>
